(function () {
  'use strict';

  var root = document.querySelector('[data-mu-country-modal]');
  var configNode = document.getElementById('MuCountryConfig');
  if (!root || !configNode) return;

  var config;
  try {
    config = JSON.parse(configNode.textContent);
  } catch (error) {
    console.warn('[Mundo Unico Geo] No fue posible leer la configuración.', error);
    return;
  }

  var dialog = root.querySelector('[role="dialog"]');
  var title = root.querySelector('[data-mu-dialog-title]');
  var manualView = root.querySelector('[data-mu-manual-view]');
  var recommendationView = root.querySelector('[data-mu-recommendation-view]');
  var recommendationBody = root.querySelector('[data-mu-recommendation-body]');
  var detectedFlag = root.querySelector('[data-mu-detected-flag]');
  var goLink = root.querySelector('[data-mu-recommendation-go]');
  var stayButton = root.querySelector('[data-mu-recommendation-stay]');
  var storageKey = 'muGeoPreference:v1';
  var lastFocusedElement = null;
  var detectedCountry = null;

  function asNumber(value, fallback) {
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  var rememberDays = Math.max(0, asNumber(config.rememberDays, 30));
  var delayMs = Math.max(0, asNumber(config.delayMs, 700));

  function safeStorage(storage, operation, fallback) {
    try {
      return operation(storage);
    } catch (error) {
      return fallback;
    }
  }

  function readPreference() {
    if (rememberDays === 0) {
      return safeStorage(window.sessionStorage, function (storage) {
        var raw = storage.getItem(storageKey);
        if (!raw) return null;
        var value = JSON.parse(raw);
        if (!value || !value.country) {
          storage.removeItem(storageKey);
          return null;
        }
        return value;
      }, null);
    }
    return safeStorage(window.localStorage, function (storage) {
      var raw = storage.getItem(storageKey);
      if (!raw) return null;
      var value = JSON.parse(raw);
      if (!value || !value.country || !value.expiresAt || Date.now() >= value.expiresAt) {
        storage.removeItem(storageKey);
        return null;
      }
      return value;
    }, null);
  }

  function savePreference(country, action) {
    if (rememberDays === 0) {
      safeStorage(window.sessionStorage, function (storage) {
        storage.setItem(storageKey, JSON.stringify({
          country: country,
          action: action
        }));
      });
      return;
    }
    safeStorage(window.localStorage, function (storage) {
      storage.setItem(storageKey, JSON.stringify({
        country: country,
        action: action,
        expiresAt: Date.now() + (rememberDays * 24 * 60 * 60 * 1000)
      }));
    });
  }

  function toTitleCase(value) {
    return String(value || '').toLowerCase().replace(/(^|[\s-])([a-záéíóúüñ])/g, function (match, separator, letter) {
      return separator + letter.toUpperCase();
    });
  }

  function replaceNameTokens(template, token, value) {
    var name = String(value || '');
    var titleToken = token.charAt(0).toUpperCase() + token.slice(1);
    return String(template)
      .split('[' + token + ']').join(name.toLowerCase())
      .split('[' + titleToken + ']').join(toTitleCase(name))
      .split('[' + token.toUpperCase() + ']').join(name.toUpperCase());
  }

  function replaceTokens(template, country) {
    var selected = config.countries[country] || {};
    var output = String(template || '');
    output = replaceNameTokens(output, 'country', selected.name || country);
    output = replaceNameTokens(output, 'current', config.currentName || 'esta tienda');
    return output.split('[currency]').join(selected.currency || '');
  }

  function getFocusableElements() {
    return Array.prototype.slice.call(dialog.querySelectorAll(
      'a[href]:not([hidden]), button:not([disabled]):not([hidden]), [tabindex]:not([tabindex="-1"]):not([hidden])'
    )).filter(function (element) {
      return element.offsetParent !== null;
    });
  }

  function openDialog(mode, country) {
    lastFocusedElement = document.activeElement;
    var isRecommendation = mode === 'recommendation';
    manualView.hidden = isRecommendation;
    recommendationView.hidden = !isRecommendation;
    detectedFlag.hidden = !isRecommendation;

    if (isRecommendation && config.countries[country]) {
      var selected = config.countries[country];
      detectedCountry = country;
      title.textContent = replaceTokens(config.recommendationTitle, country);
      recommendationBody.textContent = replaceTokens(config.recommendationBody, country);
      detectedFlag.src = '//cdn.shopify.com/static/images/flags/' + country.toLowerCase() + '.svg';
      detectedFlag.alt = 'Bandera de ' + selected.name;
      goLink.href = buildDestinationUrl(selected.url, country, 'recommendation');
      goLink.textContent = replaceTokens(config.goLabel, country);
      stayButton.textContent = replaceTokens(config.stayLabel, country);
    } else {
      detectedCountry = null;
      title.textContent = config.manualTitle;
    }

    root.hidden = false;
    document.documentElement.classList.add('mu-country-modal-open');
    window.requestAnimationFrame(function () {
      dialog.focus();
    });
  }

  function closeDialog(rememberStay) {
    if (rememberStay) savePreference(config.currentCountry, 'stay');
    root.hidden = true;
    document.documentElement.classList.remove('mu-country-modal-open');
    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus();
    }
  }

  function buildDestinationUrl(baseUrl, country, source) {
    var url;
    try {
      url = new URL(baseUrl, window.location.origin);
    } catch (error) {
      return baseUrl;
    }
    url.searchParams.set('mu_geo_choice', country);
    url.searchParams.set('mu_geo_source', source);
    Array.prototype.forEach.call(new URLSearchParams(window.location.search), function (value, key) {
      if (/^utm_/i.test(key) && !url.searchParams.has(key)) url.searchParams.set(key, value);
    });
    return url.toString();
  }

  function consumeHandoff() {
    var params = new URLSearchParams(window.location.search);
    var choice = String(params.get('mu_geo_choice') || '').toUpperCase();
    if (!config.countries[choice] || choice !== config.currentCountry) return false;

    savePreference(choice, 'country-selection');

    params.delete('mu_geo_choice');
    params.delete('mu_geo_source');
    var cleanQuery = params.toString();
    var cleanUrl = window.location.pathname + (cleanQuery ? '?' + cleanQuery : '') + window.location.hash;
    window.history.replaceState({}, document.title, cleanUrl);
    return true;
  }

  function getPreviewCountry() {
    var params = new URLSearchParams(window.location.search);
    var requested = String(params.get('mu_geo_test') || '').toUpperCase();
    var isPreview = Boolean(window.Shopify && window.Shopify.designMode) || params.has('preview_theme_id');
    return isPreview && config.countries[requested] ? requested : null;
  }

  function getDetectedCountry() {
    var previewCountry = getPreviewCountry();
    if (previewCountry) return Promise.resolve(previewCountry);

    var rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    var endpoint = rootPath + 'browsing_context_suggestions.json?country%5Benabled%5D=true';
    return window.fetch(endpoint, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.json();
      })
      .then(function (data) {
        var country = data && data.detected_values && data.detected_values.country;
        return String(country && (country.handle || country.iso_code) || '').toUpperCase();
      })
      .catch(function (error) {
        console.warn('[Mundo Unico Geo] No fue posible detectar el país.', error);
        return '';
      });
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-mu-country-open]');
    if (opener) {
      event.preventDefault();
      openDialog('manual');
      return;
    }

    var closer = event.target.closest('[data-mu-country-close]');
    if (closer) {
      event.preventDefault();
      closeDialog(Boolean(detectedCountry));
      return;
    }

    var option = event.target.closest('[data-mu-country-option]');
    if (option) {
      var targetCountry = option.getAttribute('data-country-code');
      if (targetCountry === config.currentCountry) {
        event.preventDefault();
        savePreference(config.currentCountry, 'country-selection');
        closeDialog(false);
        return;
      }
      event.preventDefault();
      window.location.assign(buildDestinationUrl(option.href, targetCountry, 'manual'));
    }
  });

  stayButton.addEventListener('click', function () {
    closeDialog(true);
  });

  goLink.addEventListener('click', function () {
    if (detectedCountry) savePreference(detectedCountry, 'recommendation');
  });

  document.addEventListener('keydown', function (event) {
    if (root.hidden) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeDialog(Boolean(detectedCountry));
      return;
    }
    if (event.key !== 'Tab') return;
    var focusable = getFocusableElements();
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  var arrivedFromAnotherStore = consumeHandoff();
  if (!config.autoPrompt || arrivedFromAnotherStore) return;

  var preference = readPreference();
  if (preference && preference.country === config.currentCountry) return;

  window.setTimeout(function () {
    getDetectedCountry().then(function (country) {
      if (!config.countries[country] || country === config.currentCountry) return;
      openDialog('recommendation', country);
    });
  }, delayMs);
})();

